var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_c('v-color-picker',{attrs:{"hide-canvas":true,"hide-sliders":true,"hide-inputs":true,"mode":"hexa","show-swatches":true,"width":"100%"},model:{value:(_vm.selectedColor),callback:function ($$v) {_vm.selectedColor=$$v},expression:"selectedColor"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }